import { ChemistryLitElement } from '@adornis/chemistry/chemistry-tailwind-lit-element.js';
import { css } from '@adornis/chemistry/directives/css.js';
import type { Renderable } from '@adornis/chemistry/renderable.js';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

/**
 * @customElement chancen-component-info-icon
 */
@customElement('chancen-component-info-icon')
export class ChancenComponentInfoIcon extends ChemistryLitElement {
  @property() text: Renderable = '';

  override render() {
    return html` <cr-icon ${css({ color: this.colors.secondary, fontSize: '1.4rem' })}>
      info
      <cr-tooltip>
        <cr-text ${css({ maxWidth: '400px' })}>${this.text}</cr-text>
      </cr-tooltip>
    </cr-icon>`;
  }
}
